<template>
    <div v-if="hdPage"
        class="hd-runtime-main"
        :class="{fixedPage: isNotStarted || isExpired}">
        <!--动态组件，渲染不同页面-->
        <component :is="hdPage"
            :activityObj="formCustom"></component>
    </div>
</template>
<script>
import navigation from './navigation';
import thematicActivity from './thematicActivity';
import guideModal from './dynamicAttr/modal/guideModal';
import signIn from './sign-in';
import { Dialog, Toast } from 'vant';
import wx from 'weixin-js-sdk';
import utils, {
  filterInvalidField,
  AllLoginTypeHandler,
  updateUserInfoCache,
  loadAlipayWebViewScript,
  loadAlipayJsapiScript,
} from '../../../utils/comUtils.js';
import { ActivityType, FormType, MiniType, QuestionLimitPeriodCondition } from '../../../commons/commonVariables.js';
import { CoordinateType } from './lucky-draw/common/global-variable';
import raffleMain from './lucky-draw/raffle-main.vue';
import { config } from '@/api/config.js';
import signInGift from './sign-in-gift';
import activityManagement from './activityManagement';
import customForm from './customForm'; // 自定义表单-普通表单，用于提交
import submittedForm from './submittedForm'; // 自定义表单-普通表单，用于查看
import topicPK from './topicPK'; // 自定义表单-话题PK
import interestForm from './interest-form/interestForm'; // 自定义表单-趣味表单
import { getEnvMark, getSignUrl, getPosition } from '../../vibrantRubikCube/runtime/common-methods/utils';
import { EnvMark } from './lucky-draw/common/global-variable';
export default {
  components: {
    customForm,
    navigation,
    submittedForm,
    thematicActivity,
    signIn,
    topicPK,
    guideModal,
    raffleMain,
    signInGift,
    interestForm,
    activityManagement,
  },
  data() {
    return {
      memberCenterId: '',
      member: false,
      accessToken: '',
      userToken: '',
      code: '',
      activityCode: '',
      userUnionid: '',
      userOpenid: '',
      alipayUserId: '',
      headimgurl: '',
      nickName: '',
      hnId: '',
      oldActivity: [],
      formCustom: {},
      isRefsh: false, //是否获取code后刷新页面
      isNotStarted: false, //未开始
      isExpired: false, //过期
      isFromExpired: false, // 自定义表单过期了
      hdPage: '',
      questionList: [
        {
          questionType: '',
          title: '',
          desc: '',
          mustFlag: '',
          optionList: [
            {
              optionCode: '',
              optionContent: '',
            },
          ],
        },
      ],
      ruleValidate: {},
      loginCount: '0', //半小时之内，参与表单的次数
      submitedTimes: '',
      questionType: null,
      isLoginFlag: false,
      userObj: {},
      activityTypeFlag: '',
      // 活动跳转时，上一级活动的页面名称
      parentPage: '',
      // 活动跳转时，上一级活动的活动编码
      parentActivityCode: '',
      formType: '', // 自定义表单对应的表单类型
      pointsMallInfo: {}, //积分商城跳转过来的的用户信息，
      userId: '', // 用户ID
      from: '', // 用户ID来源，有：APKM
      locationInfo: {}, // 小程序/积分商城传过来的经纬度、坐标系信息,
      deviceBrand: '', //小程序传过来的手机厂商
      isFromPageCenter: false, // 是否来自活动中心页跳转
      formData: {},
      positionInfo: {},
    };
  },
  created() {
    const activityResult = sessionStorage.getItem('activityResult');
    if (activityResult && activityResult != {}) document.title = JSON.parse(activityResult).activityName;
    this.questionList = [];
    let params = '';
    let shareType = '';
    let wi = '';
    let cpsId = ''; // 渠道码
    let passwd = ''; // 口令（小程序）
    const routeQuery = this.$route.query;
    console.log('跳转h5带的参数', routeQuery);
    if (routeQuery) {
      this.parentPage = routeQuery.parentPage || '';
      this.parentActivityCode = routeQuery.parentActivityCode || '';
      // 活动编码
      params = routeQuery.activityCode || '';
      // 用户登录Hi荣耀小程序标识
      if (routeQuery.isLoginFlag) {
        sessionStorage.setItem('isLoginFlag', routeQuery.isLoginFlag);
      }
      // 从小程序传过来的手机厂商，缓存下来
      this.deviceBrand = (routeQuery.deviceBrand && routeQuery.deviceBrand.toLowerCase()) || sessionStorage.getItem('deviceBrand');
      sessionStorage.setItem('deviceBrand', this.deviceBrand);
      const isClickNextPage = routeQuery.isClickNextPage;
      const clickIndex = routeQuery.clickIndex;
      const clickListId = routeQuery.clickListId;
      const urlParams = new URLSearchParams(decodeURIComponent(window.location.search));
      // 小程序验证完身份回到小程序会自动领券，领过一次之后删掉路由参数，防止进入循环
      if (isClickNextPage || clickIndex || clickListId) {
        sessionStorage.setItem('isClickNextPage', isClickNextPage);
        sessionStorage.setItem('clickIndex', clickIndex);
        sessionStorage.setItem('clickListId', clickListId);
        if (isClickNextPage) urlParams.delete('isClickNextPage');
        if (clickIndex) urlParams.delete('clickIndex');
        if (clickListId) urlParams.delete('clickListId');
        const newUrl = new URL(window.location);
        newUrl.search = urlParams.toString();
        history.pushState({}, '', newUrl);
      }
      // 积分商城cookie信息
      let pointsMallUserInfo = {};
      if (routeQuery.pointsmall === 'true') {
        const cookieInfo = decodeURIComponent(document.cookie);
        if (cookieInfo) {
          const pointsMallDataList = cookieInfo.split(';');
          pointsMallDataList.forEach((item) => {
            if (item.indexOf('userInfo') !== -1) {
              pointsMallUserInfo = JSON.parse(item.split('=')[1]);
            }
          });
        }
      }
      // 处理积分商城传过来的cookie信息
      this.handlePointsMallData(pointsMallUserInfo, routeQuery);
      // activityTypeFlag阵地类型 1=hi荣耀 2=直营店
      this.activityTypeFlag = routeQuery.activityTypeFlag || MiniType.HiHonor;
      // 存储分享属性
      shareType = routeQuery.shareType || '';
      wi = routeQuery.wi || '';
      cpsId = routeQuery.cpsId || '';
      passwd = routeQuery.passwd || '';
      // 获取用户ID及来源
      this.userId = routeQuery.userId || ''; // 用户ID
      this.from = routeQuery.from || ''; // 用户ID来源

      // 判断是否来自活动中心页的跳转
      this.isFromPageCenter = routeQuery.activityListId ? true : false;
      if (this.isFromPageCenter) {
        sessionStorage.setItem('activityListId', routeQuery.activityListId);
      }
    }

    // 阵地类型 1=hi荣耀 2=直营店
    sessionStorage.setItem('activityTypeFlag', this.activityTypeFlag);

    if (params instanceof Array) {
      params = params[0];
    }
    console.log('hdmain-params', params);

    if (!sessionStorage.getItem('shareType')) {
      sessionStorage.setItem('shareType', shareType);
    }
    if (!sessionStorage.getItem('wi')) {
      sessionStorage.setItem('wi', wi);
    }
    if (cpsId) {
      // 如果存在cpsId才存入缓存，活动编排埋码时可区分，关闭浏览器窗口后会被清除
      sessionStorage.setItem('cpsId', cpsId);
    }

    if (passwd) {
      sessionStorage.setItem('passwd', passwd);
    }
    // 支付宝用户userId
    this.alipayUserId = sessionStorage.getItem('alipayUserId') || '';

    // 微信场景，设置当前用户是否为会员，用于控制是否展示登录组件。初始默认为是会员，即不显示登录组件
    sessionStorage.setItem('isMemberId', 'true');
    this.initData(params, routeQuery);
    this.handleNumberOfScans(params);
    // 大转盘按门店生成，此种场景要session缓存门店编码，用于埋码
    if (params && params.indexOf('_') > -1) {
      const storeCode = params.split('_')[1];
      if (storeCode) {
        sessionStorage.setItem('eventTrackingData', JSON.stringify({ storeCode: storeCode }));
      }
    }
    // 支付宝浏览器或者支付宝小程序环境就加载一次alipaysdk
    this.loadAliPaySDK();
  },

  //初始化后调用
  mounted: function () {
    wx.hideAllNonBaseMenuItem();
  },
  destroyed() {
    sessionStorage.removeItem('shareType');
    sessionStorage.removeItem('wi');
    sessionStorage.removeItem('eventTrackingData');
  },
  methods: {
    handlePointsMallData(pointCookie, routeQuery) {
      if (Object.prototype.toString.call(pointCookie) === '[object Object]') {
        this.pointsMallInfo = pointCookie;
      } else {
        this.pointsMallInfo = {};
      }
      let userValues = [];
      if (this.pointsMallInfo) {
        userValues = Object.values(this.pointsMallInfo);
      }
      // pointsmall代表是从积分商城跳到H5活动页面来的标识
      if (routeQuery.pointsmall === 'true') {
        // 判断积分商城sessionStorage有没有存useInfo信息，有就不需要登录，没有就要登录
        this.isLoginFlag = userValues.length === 0 ? false : true;
        // 微信用户openId及unionId
        this.userUnionid = this.pointsMallInfo.userUnionid;
        this.userOpenid = this.pointsMallInfo.userOpenid;
        this.member = this.pointsMallInfo.memberId ? true : false;
        sessionStorage.setItem('isLoginFlag', this.isLoginFlag);
        this.userObj = {
          openId: this.userOpenid,
          unionid: this.userUnionid,
          accessToken: this.pointsMallInfo.accessToken,
          userToken: this.pointsMallInfo.userToken,
          memberCenterId: this.pointsMallInfo.memberId,
          member: this.member,
        };
        updateUserInfoCache(this.userObj);
      } else {
        // 其他情况跳活动页
        this.isLoginFlag = sessionStorage.getItem('isLoginFlag') === 'true' || sessionStorage.getItem('isLoginFlag') === true ? true : false;
        // 微信用户openId及unionId
        this.userUnionid = sessionStorage.getItem('userUnionid') || '';
        this.userOpenid = sessionStorage.getItem('userOpenid') || '';
      }
    },
    // 统计扫码次数
    handleNumberOfScans(param) {
      const params = {
        activityCode: '',
        channel: 'magicActivity',
        channelCode: '',
      };
      if (param && param.indexOf('_') > -1) {
        const storeCode = param.split('_')[1] || '';
        params.channelCode = storeCode.substring(0, 15);
      }
      const code = param.match(/(HD\d{13})/);
      if (code) {
        params.activityCode = code[0]; // 获取匹配的字符串
      } else {
        params.activityCode = '';
      }
      console.log('纪录扫码、链接进入活力魔方活动次数====params', params);
      if (params.activityCode && params.activityCode.substr(0, 2) === 'HD') {
        this.$api.post({
          sc: 'mobileMarketing',
          url: 'miniMemberAndCommunityStatistics/countJoinMemberScanNum',
          params,
        });
      }
    },
    getApplication() {
      const versions = this.$browser.versions;
      if (versions.mobile) {
        //判断是否是移动设备打开。
        const ua = navigator.userAgent.toLowerCase(); //获取判断用的对象
        if (ua.match(/MicroMessenger/i) == 'micromessenger') {
          //在微信中打开
          return 'wechat';
        } else if (/AlipayClient/i.test(ua)) {
          // 支付宝
          return 'Alipay';
        }
      } else {
        return 'pc';
      }
    },

    //新微信登录 ---如果未登录用户要先跳转Hi荣耀小程序获取一次性登陆code，再回到h5页面请求用户信息
    wxLoginNew() {
      const wxLoginCode = (this.$route.query && this.$route.query.wxLoginCode) || '';
      if (wxLoginCode) {
        const sc = this.$memberMixSwitch ? 'mobileWxMix' : 'mobileWx';
        const url = this.$memberMixSwitch ? 'quicklogin' : `getsession?code=${wxLoginCode}`;
        const headers = this.$memberMixSwitch
          ? {
              'content-type': 'application/json',
              accept: 'application/json;charset=UTF-8',
            }
          : { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' };
        const params = this.$memberMixSwitch ? { code: wxLoginCode } : '';
        const p = new Promise((resolve, reject) => {
          this.$api.post({
            noLoading: true,
            sc: sc,
            url: url,
            params: params,
            headers: headers,
            success: (r) => {
              this.userUnionid = (r.data && r.data.unionid) || '';
              this.userOpenid = (r.data && r.data.openid) || '';
              this.accessToken = (r.data && r.data.accessToken) || '';
              this.userToken = (r.data && r.data.usertoken) || '';
              this.memberCenterId = (r.data && r.data.memberId) || '';
              this.member = this.memberCenterId ? true : false;
              sessionStorage.setItem('userUnionid', this.userUnionid);
              sessionStorage.setItem('userOpenid', this.userOpenid);
              sessionStorage.setItem('accessToken', this.accessToken);
              sessionStorage.setItem('userToken', this.userToken);
              // 以返回的result内的参数，作为是否登入成功的标识
              const showLoginFlag = r.result === 1 && this.userUnionid && this.userOpenid && this.accessToken && this.userToken ? true : false;
              const showLoginFlagMix = r.code === '666666' && this.userUnionid && this.userOpenid && this.accessToken && this.userToken ? true : false;
              const flag = this.$memberMixSwitch ? showLoginFlagMix : showLoginFlag;
              sessionStorage.setItem('isLoginFlag', flag);
              // 是否是会员（微信、支付宝场景）
              sessionStorage.setItem('isMemberId', this.member);
              this.userObj = {
                openId: this.userOpenid,
                unionid: this.userUnionid,
                accessToken: this.accessToken,
                userToken: this.userToken,
                memberCenterId: this.memberCenterId,
                member: this.member,
              };
              if (this.$memberMixSwitch) {
                this.nickName = (r.data && r.data.nickName) || '默认用户';
                this.headimgurl = (r.data && r.data.avatarUrl) || require('../../../../static/runtime/images/magic/award/userImg.png');
                this.userObj.nickName = this.nickName;
                this.userObj.headimgurl = this.headimgurl;
              }
              sessionStorage.setItem('userInfo', JSON.stringify(this.userObj));
              this.$memberMixSwitch ? resolve(showLoginFlagMix) : resolve(showLoginFlag);
            },
            failure: () => {
              sessionStorage.setItem('isLoginFlag', 'false');
              reject('登录失败，请重试');
            },
          });
        });
        return p;
      } else {
        // 未传wxLoginCode，设置isLoginFlag为FALSE，表示未登录
        sessionStorage.setItem('isLoginFlag', 'false');
        return false;
      }
    },

    // 支付宝登录
    async alipayLoginNew() {
      const aliLoginCode = (this.$route.query && this.$route.query.wxLoginCode) || '';
      if (aliLoginCode) {
        return new Promise((resolve, reject) => {
          const axios = require('axios');
          const qs = require('qs');
          const url = this.$memberMixSwitch ? `${config.hdBaseUrl}/mobileZuul/alipay/quicklogin` : `${config.hdBaseUrl}/mobileZuul/zfb/staticlogin`;
          const data = this.$memberMixSwitch ? { code: aliLoginCode } : qs.stringify({ code: aliLoginCode });
          const headers = this.$memberMixSwitch
            ? {
                'content-type': 'application/json',
                accept: 'application/json;charset=UTF-8',
              }
            : { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' };
          const param = {
            method: 'post',
            url: url,
            headers: headers,
            data: data,
          };
          axios(param)
            .then((response) => {
              const isSuccess = this.$memberMixSwitch
                ? response.data && response.data.code === '666666' && response.data.data
                : response.data && response.data.result === 1 && response.data.data;
              if (isSuccess) {
                const tempData = response.data.data;
                this.isRefsh = false;
                this.alipayUserId = tempData.unionid;
                this.accessToken = tempData.accessToken || '';
                this.userToken = tempData.usertoken || '';
                this.memberCenterId = tempData.memberId || '';
                this.member = this.memberCenterId ? true : false;
                sessionStorage.setItem('alipayUserId', tempData.unionid);
                sessionStorage.setItem('userInfo', JSON.stringify(tempData));
                sessionStorage.setItem('accessToken', tempData.accessToken);
                sessionStorage.setItem('userToken', tempData.usertoken);
                // 以返回的result内的参数，作为是否登入成功的标识
                const showLoginFlag = response.data.result === 1 && this.alipayUserId && this.accessToken && this.userToken ? true : false;
                const showLoginFlagMix = response.data.code === '666666' && this.alipayUserId && this.accessToken && this.userToken ? true : false;
                const flag = this.$memberMixSwitch ? showLoginFlagMix : showLoginFlag;
                sessionStorage.setItem('isLoginFlag', flag);
                sessionStorage.setItem('isMemberId', this.member);
                this.userObj = {
                  unionid: this.alipayUserId,
                  accessToken: this.accessToken,
                  userToken: this.userToken,
                  memberCenterId: this.memberCenterId,
                  member: this.member,
                };
                if (this.$memberMixSwitch) {
                  this.nickName = tempData.nickName || '默认用户';
                  this.headimgurl = tempData.avatarUrl || require('../../../../static/runtime/images/magic/award/userImg.png');
                  this.userObj.nickName = this.nickName;
                  this.userObj.headimgurl = this.headimgurl;
                }
                sessionStorage.setItem('userInfo', JSON.stringify(this.userObj));
                this.$memberMixSwitch ? resolve(showLoginFlagMix) : resolve(showLoginFlag);
              } else {
                sessionStorage.setItem('isLoginFlag', 'false');
                resolve(false);
              }
            })
            .catch(function (error) {
              console.log(error);
              sessionStorage.setItem('isLoginFlag', 'false');
              reject('登录失败，请刷新重新登录');
            });
        });
      }
      return false;
    },

    // 微信和支付宝侧: 获取用户昵称和头像
    getUserNicknameAndAvatar() {
      return new Promise((resolve, reject) => {
        this.$api.get({
          sc: 'mobileUser',
          url: 'user2c/getNickUrl',
          success: (r) => {
            if (r.code === 200 && r.result) {
              this.nickName = (r.result.displayname && r.result.displayname.anonymizedText) || '';
              this.headimgurl = r.result.avatarurl || '';
              const userObj = JSON.parse(sessionStorage.getItem('userInfo')) || {};
              userObj.nickName = this.nickName;
              userObj.headimgurl = this.headimgurl;
              sessionStorage.setItem('userInfo', JSON.stringify(userObj));
              resolve(r);
            } else {
              // 接口未返回数据，则使用默认值
              this.nickName = '默认用户';
              this.headimgurl = require('../../../../static/runtime/images/magic/award/userImg.png');
              const userObj = JSON.parse(sessionStorage.getItem('userInfo')) || {};
              userObj.nickName = this.nickName;
              userObj.headimgurl = this.headimgurl;
              sessionStorage.setItem('userInfo', JSON.stringify(userObj));
              resolve(true);
            }
          },
          failure: () => {
            reject('未获取到用户昵称及头像');
          },
        });
      });
    },

    // 删除活动信息和活动编码的本地缓存
    removeStorageActivity() {
      const self = this;
      //删除缓存
      self.$utils.removeStorageItem('activityCode');
      self.$utils.removeStorageItem('activityResult');
    },
    //加载活动详情数据，params表示活动编码
    initData(params, routeQuery) {
      const self = this;
      let code = params.match(/(HD\d{13})/);
      if (code) {
        code = code[0]; // 获取匹配的字符串
      } else {
        code = '';
      }
      self.activityCode = code;
      const activityCode = self.$utils.getStorageItem('activityCode');
      // 活动编码已存在，无需再查询一次接口获取活动信息
      if (activityCode === code) {
        console.log('activityCode=========>这里这里这里', self.$utils.getStorageItem('activityCode'));
        console.log('code========>这里这里这里', self.activityCode);
        const activityResult = self.$utils.getStorageItemObj('activityResult');
        self.formCustom = activityResult;
        self.removeStorageActivity();
        self.checkLoginType(activityResult);
        if (self.$utils.isWxBrowser()) {
          console.log('最外层微信config方法');
          self.weChatOpenAuth();
        }
      } else {
        self.$api.post({
          noLoading: true,
          sc: 'mobileMarketingH5',
          url: 'navigationActivity/getByActivityIdForH5?idOrCode=' + code,
          success: async (r) => {
            const result = r.result || {};
            if (!result || JSON.stringify(result) === '{}') {
              return;
            }
            self.formType = result.formType || '';
            // 记录原登录类型，用于客户端是否正确打开判断逻辑
            sessionStorage.setItem('originLoginType', result.loginType);
            // 全部登录类型处理
            result.loginType = AllLoginTypeHandler(result.loginType);
            sessionStorage.setItem('activityType', result.activityType);
            sessionStorage.setItem('activityResult', JSON.stringify(result));
            sessionStorage.setItem('activityPictureUrl', result.activityPictureUrl);
            sessionStorage.setItem('loginType', result.loginType);
            sessionStorage.setItem('userType', result.userType);
            // 活动名称
            const activityName = result.activityName || '';
            // 活动类型
            const activityType = routeQuery.ay || '';
            // 企微导购id
            const guideUserId = routeQuery.GUID || '';
            // 门店编码
            const storeCode = routeQuery.SC || '';
            if (guideUserId && storeCode) {
              const eventTrackingObj = {
                activityName: activityName,
                activityType: activityType,
                guideUserId: guideUserId,
                storeCode: storeCode,
              };
              sessionStorage.setItem('eventTrackingData', JSON.stringify(eventTrackingObj));
            }
            // 门店导航，大转盘，普通表单，专题活动，只有签到(包括普通签到和线上预约线下签到)，签到有礼获取位置权限弹框展示与否
            sessionStorage.setItem('positioningFlag', result.positioningFlag);
            let shareIconUrl = '';
            // 处理小程序/积分商城传过来的经纬度、坐标系信息
            await this.handleLocationInfo(result.activityType);
            if (result.shareIconUrl) {
              if (result.shareIconUrl.indexOf('{') > -1) {
                shareIconUrl = self.$utils.getImageUrl(JSON.parse(result.shareIconUrl).file);
              } else {
                shareIconUrl = self.$utils.getImageUrl(result.shareIconUrl);
              }
            }
            if (result.activityType == ActivityType.activityArrangement) {
              //活动编排
              self.isMixedActivity(result);
              const wxShareParam = {
                code: result.activityCode,
                shareTitle: result.shareTitle,
                shareDesc: result.shareDesc,
                shareIconUrl: shareIconUrl,
                shareFlag: result.shareFlag,
              };
              sessionStorage.setItem('wxShareParam', JSON.stringify(wxShareParam));
              const crtlParams = {
                loginType: result.loginType,
                activityStatus: result.activityStatus,
              };
              sessionStorage.setItem('crtlParams', JSON.stringify(crtlParams));
              sessionStorage.setItem('associationActivityStatus', result.activityStatus);
              sessionStorage.setItem('associationActivityCode', result.activityCode);
            } else if (result.activityType == ActivityType.customForm) {
              // 自定义表单
              self.formCustom = result;
              const wxShareParam = {
                code: result.activityCode,
                shareTitle: result.shareTitle,
                shareDesc: result.shareDesc,
                shareIconUrl: shareIconUrl,
                shareFlag: result.shareFlag,
              };
              sessionStorage.setItem('wxShareParam', JSON.stringify(wxShareParam));
              //缓存活动code和活动详情数据.避免微信登录重定向回来后再次调用服务
              self.$utils.setStorageItem('activityCode', code);
              self.$utils.setStorageItemObj('activityResult', result);
              self.$utils.setStorageItemObj('extendConfig', result.activityConfig);
              document.title = result.activityName;
              self.checkLoginType(result);
            } else {
              //result.loginType = 'none';
              self.formCustom = result;
              //缓存活动code和活动详情数据.避免微信登录重定向回来后再次调用服务
              self.$utils.setStorageItem('activityCode', code);
              self.$utils.setStorageItemObj('activityResult', result);
              if (result.extendConfigStr) {
                self.$utils.setStorageItemObj('extendConfig', JSON.parse(result.extendConfigStr));
              }
              document.title = result.activityName;
              self.checkLoginType(result);
            }
            if (self.$utils.isWxBrowser()) {
              console.log('最外层微信config方法');
              self.weChatOpenAuth();
            }
          },
        });
      }
    },
    // 处理小程序/积分商城传过来的经纬度、坐标系信息，活力魔方活动统一使用GCJ02坐标系
    async handleLocationInfo() {
      const routeQuery = this.$route.query;
      let locationInfo = {};
      if (routeQuery) {
        // 积分商城 --- WGS84坐标系
        if (routeQuery.pointsmall === 'true') {
          const cookieInfo = decodeURIComponent(document.cookie);
          if (cookieInfo) {
            let pointsMallLocationInfo = {};
            const pointsMallDataList = cookieInfo.split(';');
            pointsMallDataList.forEach((item) => {
              if (item.indexOf('wapLocationInfo') !== -1) {
                pointsMallLocationInfo = JSON.parse(item.split('=')[1]);
              }
            });
            if (pointsMallLocationInfo && pointsMallLocationInfo.longitude && pointsMallLocationInfo.latitude && pointsMallLocationInfo.currentCity) {
              locationInfo = {
                longitude: pointsMallLocationInfo.longitude,
                latitude: pointsMallLocationInfo.latitude,
                cityName: pointsMallLocationInfo.currentCity,
                coordinateType: CoordinateType.WGS84,
              };
            }
            await this.handlePositionFromWgs84ToGcj02(locationInfo);
          }
        } else {
          // 小程序 --- GCJ02坐标系
          if (routeQuery.longitude && routeQuery.latitude && routeQuery.cityName && routeQuery.locationType) {
            locationInfo = {
              longitude: routeQuery.longitude,
              latitude: routeQuery.latitude,
              cityName: routeQuery.cityName,
              coordinateType: CoordinateType.GCJ02,
            };
            sessionStorage.setItem('locationInfo', JSON.stringify(locationInfo));
          }
          await this.getAdministrativeRegionsID();
        }
      }
    },
    // wgs84坐标转gcj02坐标
    handlePositionFromWgs84ToGcj02(locationInfo) {
      const params = {
        longitude: locationInfo.longitude,
        latitude: locationInfo.latitude,
        coordinateType: CoordinateType.WGS84,
      };
      this.$api.post({
        sc: 'mobileMarketing',
        url: 'storeInfoManager/storeInfo/convertInputLongitudeLatitude',
        params: params,
        success: async (r) => {
          if (r.code == 200 && r.result && r.result.gcj02Longitude && r.result.gcj02Latitude) {
            locationInfo.coordinateType = CoordinateType.GCJ02;
            locationInfo.longitude = r.result.gcj02Longitude;
            locationInfo.latitude = r.result.gcj02Latitude;
          }
          sessionStorage.setItem('locationInfo', JSON.stringify(locationInfo));
          await this.getAdministrativeRegionsID();
        },
        fail: async (err) => {
          console.log('wgs84坐标转gcj02坐标失败', err);
          sessionStorage.setItem('locationInfo', JSON.stringify(locationInfo));
          await this.getAdministrativeRegionsID();
        },
      });
    },
    /**
     * 新增一个接口入参小程序或者积分商城过来的地理信息，获取到一个行政区域ID，
     * 为了给专题活动，大转盘，签到，自定义表单下面所有场景领取奖励接口入参,各个场景要记录所在的省市区
     */
    async getAdministrativeRegionsID() {
      let regionParams = {};
      const positioningFlag = sessionStorage.getItem('positioningFlag') === 'true' ? true : false;
      if (positioningFlag) {
        const positionInfo = await getPosition();
        regionParams = {
          longitude: positionInfo.longitude || '',
          latitude: positionInfo.latitude || '',
          coordinateType: positionInfo.coordinateType || '',
        };
      } else {
        const locationInfo = JSON.parse(sessionStorage.getItem('locationInfo')) || {};
        regionParams = {
          longitude: locationInfo.longitude || '',
          latitude: locationInfo.latitude || '',
          coordinateType: locationInfo.coordinateType || '',
        };
        if (!regionParams.longitude && !regionParams.latitude && !regionParams.coordinateType) {
          return;
        }
      }
      this.$api.post({
        sc: 'mobileMarketing',
        url: 'regionManage/getRegionIdByCoordinates',
        params: regionParams,
        success: (r) => {
          if (r.code == 200 && r.result) {
            const adminRegionsID = r.result;
            sessionStorage.setItem('adminRegions', JSON.stringify(adminRegionsID));
          }
        },
        failure: (err) => {
          console.log('未获取行政区域ID', err);
          resolve('未获取行政区域ID');
        },
      });
    },
    /*
     * 无需登录营销统计接口
     * @author <fangyan f84162999>
     */
    handleInsertUserMaigc() {
      const activityType = sessionStorage.getItem('activityType');
      let params = {
        comfromModelType: activityType,
        comfromModelValue: this.activityCode,
        attributeFrom: 'magicActivity',
      };
      if (this.hnId) {
        params = {
          ...params,
          ...{ hwId: this.hnId },
        };
      } else {
        params = {
          ...params,
          ...{
            nigname: this.nickName,
            unionId: this.userUnionid,
            openId: this.userOpenid,
            userAvatarUrl: this.headimgurl,
          },
        };
        const keys = {
          nigname: '$PrivacyPlain$',
        };
        const keyList = [
          {
            nigname: 'nigname',
            typeText: 'NAME',
            labelText: 'mktMagicUserNigname',
          },
        ];
        this.$utils.privacySave(keys, keyList, params);
      }
      this.$api.post({
        sc: 'nonauthmkt',
        url: 'userMagicController/insertUserMaigcByH5',
        params,
        success: () => {},
      });
    },

    //编排活动，查询首页code值
    isMixedActivity(result) {
      const self = this;
      self.$api.post({
        noLoading: true,
        sc: 'mobileMarketingH5',
        url: 'ArrangementActivity/queryArrangementActivityDetail/' + result.activityCode,
        success: (r) => {
          const result = r.result || '';
          const query = this.$route.query;
          console.log('query', query);
          const tmp = {
            activityCode: result,
            // 活动编排-渠道码传入下一级活动
            cpsId: sessionStorage.getItem('cpsId'), // 渠道码
            passwd: sessionStorage.getItem('passwd'), // 口令
            parentActivityCode: this.activityCode,
            parentPage: 'activityOrchestration',
            activityTypeFlag: (query && query.activityTypeFlag) || '',
            isLoginFlag: (query && query.isLoginFlag) || '',
            wxLoginCode: (query && query.wxLoginCode) || '',
          };
          const urlParam = filterInvalidField(tmp);
          // 编排活动跳转，需要增加登陆标识及相关token数据等
          this.$router.replace({
            query: urlParam,
          });
        },
      });
    },
    // 加载活动页面
    sethdPage(num) {
      const self = this;
      self.removeStorageActivity();
      const result = self.formCustom;
      if (num && result.formType == FormType.commonForm) {
        self.hdPage = 'submittedForm'; //已提交表单
      } else {
        if (result.activityType == ActivityType.storeNavigation) {
          self.hdPage = 'navigation'; //门店导航
        } else if (result.activityType == ActivityType.customForm && result.formType == FormType.topicPK) {
          self.hdPage = 'topicPK'; //话题PK表单
        } else if (result.activityType == ActivityType.customForm && result.formType == FormType.commonForm) {
          self.hdPage = 'customForm'; //填写表单-普通表单
        } else if (result.activityType == ActivityType.customForm && result.formType == FormType.interestForm) {
          self.hdPage = 'interestForm'; // 趣味表单
        } else if (result.activityType == ActivityType.thematicActivity) {
          self.hdPage = 'thematicActivity'; //专题活动
        } else if (result.activityType == ActivityType.bigTurnable) {
          self.hdPage = 'raffleMain'; //大转盘
        } else if (result.activityType == ActivityType.signIn) {
          self.hdPage = 'signIn'; //签到
        } else if (result.activityType == ActivityType.signInGift) {
          self.hdPage = 'signInGift'; //签到有礼
        } else if (result.activityType === ActivityType.activityManagement) {
          self.hdPage = 'activityManagement'; //活动管理
        }
      }
      this.handleIntoActivityProcess(result.activityType);
    },
    // 增加活动入口处统一埋码能力
    handleIntoActivityProcess(code) {
      const shareType = sessionStorage.getItem('shareType') || '';
      const loginType = sessionStorage.getItem('loginType') || '';
      let actionCode = '';
      let actionName = '';
      let title = '';
      let userId = ''; // 用户ID
      switch (code) {
        case '5':
          {
            actionCode = '500030001';
            actionName = '用户进入自定义表单页';
            title = '用户进入自定义表单页';
          }
          break;
        case '4':
          {
            actionCode = '500020001';
            actionName = '用户进入门店导航页';
            title = '用户进入门店导航页';
          }
          break;
        case '7':
          {
            actionCode = '400060003';
            actionName = '进入专题页';
            title = '进入专题页';
          }
          break;
        case '9':
          {
            actionCode = '400060001';
            actionName = '进入大转盘';
            title = '进入大转盘';
          }
          break;
        case '12':
          {
            actionCode = '500040001';
            actionName = '用户进入签到页';
            title = '用户进入签到页';
          }
          break;
        case '22':
          {
            actionCode = '400070001';
            actionName = '进入活动页面';
            title = '进入活动页面';
          }
          break;
        default:
          console.log('埋码活动类型不存在！ 活动类型', code);
      }

      // 如果用户ID来源于APKM，那么就对用户ID埋码
      if (this.from === 'APKM' && this.userId) {
        userId = this.userId;
      }

      let params = {
        actionCode: actionCode,
        actionName: actionName,
        content: {
          title: title,
          channel: loginType == 'none' ? '无需登陆' : loginType == 'wechat' ? '微信' : '支付宝',
          shareType: shareType ? shareType : '',
          activityCode: this.activityCode,
          //  上级页面名称（仅限活力魔方内部地址）
          parentPage: this.parentPage,
          //  上级活动编码（仅限活力魔方内部地址）
          parentActivityCode: this.parentActivityCode,
          experience_app_id: userId, // 如果用户ID来源于APKM，那么就对用户ID埋码，若无则为空
        },
      };
      // 消费打开链接或者小程序卡片，需要把活动的名称、活动的类型、企微导购id、门店编码进行埋码
      const eventTrackingData = JSON.parse(sessionStorage.getItem('eventTrackingData') || '{}');
      if (eventTrackingData && eventTrackingData.storeCode && eventTrackingData.guideUserId) {
        params.content.activityName = eventTrackingData.activityName;
        params.content.activityType = eventTrackingData.activityType;
        params.content.guideUserId = eventTrackingData.guideUserId;
        params.content.channelCode = eventTrackingData.storeCode;
      }
      // 如果session缓存中存在eventTrackingData，则将storeCode存入content中
      if (params.actionCode === '400060001') {
        const eventTrackingData = JSON.parse(sessionStorage.getItem('eventTrackingData'));
        if (eventTrackingData && eventTrackingData.storeCode) {
          params.content.channelCode = eventTrackingData.storeCode;
        }
      }
      utils.handleBatchReport(this, params);
    },
    //校验活动是否需要登录，是否参与过活动,活动是否开始
    checkLoginType(result) {
      console.log('校验活动是否需要登录-刚接收到的result', result);
      const self = this;
      let crtlParams = sessionStorage.getItem('crtlParams');
      console.log('校验活动是否需要登录-crtlParams', JSON.parse(crtlParams));
      const extendConfig = self.$utils.getStorageItemObj('extendConfig');
      if (crtlParams && result.activityType != ActivityType.bigTurnable) {
        crtlParams = JSON.parse(crtlParams);
        Object.assign(result, crtlParams);
      }

      sessionStorage.setItem('loginType', result.loginType);
      if (result.loginType && result.loginType != 'none') {
        const p = new Promise(function (resolve) {
          resolve('ok');
        });
        p.then(() => {
          // 本地调试
          if (window.location.host.includes('localhost') && !this.isFromPageCenter) {
            self.isLoginFlag = true;
            sessionStorage.setItem('isLoginFlag', 'true');
            self.userUnionid = config.userInfo.unionid;
            self.userOpenid = config.userInfo.openId;
            self.alipayUserId = config.userInfo.alipayUserId;
            sessionStorage.setItem('alipayUserId', self.alipayUserId);
            sessionStorage.setItem('userUnionid', self.userUnionid);
            sessionStorage.setItem('userOpenid', self.userOpenid);
            sessionStorage.setItem('userInfo', JSON.stringify(config.userInfo));
            sessionStorage.setItem('accessToken', config.userInfo.accessToken);
            sessionStorage.setItem('userToken', config.userInfo.userToken);
            // 是否是会员（微信、支付宝场景）
            sessionStorage.setItem('isMemberId', config.userInfo.member);
          }
          if (result.loginType === 'wechat') {
            if (this.userOpenid && this.isLoginFlag) {
              // 必须保证H5登录（userOpenid）和小程序登录（isLoginFlag）同时满足，否则走登录流程 wxLoginNew()方法
              self.handleInsertUserMaigc();
              // 获取导购参数，调用接口进行统计
              const guideUserId = (self.$route.query && self.$route.query.guideUserId) || '';
              const taskCode = (self.$route.query && self.$route.query.taskCode) || '';
              if (guideUserId && taskCode) {
                self.handleActivityTaskUpdate({ guideUserId, taskCode });
              }
              return true;
            } else {
              return this.wxLoginNew();
            }
          } else if (result.loginType === 'Alipay') {
            if (self.alipayUserId) {
              return true;
            } else {
              return self.alipayLoginNew();
            }
          } else {
            return false;
          }
        })
          .then((r) => {
            if ((result.loginType === 'wechat' || result.loginType === 'Alipay') && r && !this.$memberMixSwitch) {
              //获取微信侧用户昵称、头像
              return this.getUserNicknameAndAvatar();
            } else {
              return true;
            }
          })
          .then(async (r) => {
            if (r) {
              //校验用户是否参加过
              const data = await self.checkUserSubmitTo(r);
              return data;
            } else {
              return false;
            }
          })
          .then((r) => {
            if (r) {
              if (r.maximumFillInTimesFlag) {
                // 超过最大填写次数
                return self.myAlert(r.message);
              } else {
                //如果参加过活动，需要用户选择是否重新参加
                return self.myConfirm(r.message);
              }
            } else {
              return true;
            }
          })
          .then((r) => {
            //如果重新参加，清空历史数据或者如果没有参加过，则打开页面
            console.log('r', r);
            console.log('self.userUnionid', self.userUnionid);
            console.log('self.alipayUserId', self.alipayUserId);
            console.log('extendConfig', extendConfig);
            self.handleJudgeActivityPage(r, extendConfig);
          })
          .catch((err) => {
            // 捕获上述全部then的异常
            Dialog.alert({
              message: err,
            });
          });
      } else {
        self.sethdPage();
      }
    },
    // 普通表单====》判断跳转表单详情页还是跳转配置的下级页面
    jumpSubmittedFormOrNextActivity(extendConfig) {
      if (extendConfig && extendConfig.nextActivity && self.questionType !== 'pk_choice') {
        const path = '/hdmain?activityCode=' + extendConfig.nextActivity;
        this.$router.push({
          path: path,
        });
        this.$store.commit('base/setIsRouterAlive', false);
        this.$nextTick(() => this.$store.commit('base/setIsRouterAlive', true));
      } else {
        this.sethdPage(true);
      }
    },
    //校验用户是否有参与过活动
    checkUserSubmitTo() {
      const self = this;
      const extendConfig = self.$utils.getStorageItemObj('extendConfig');
      let loginType = sessionStorage.getItem('loginType');
      let crtlParams = sessionStorage.getItem('crtlParams');

      if (crtlParams) {
        crtlParams = JSON.parse(crtlParams);
        loginType = crtlParams.loginType;
      }

      if (!loginType) return false;
      if (!self.activityCode) return false;
      if (!self.userUnionid && !self.userOpenid && !self.alipayUserId) return false;

      return new Promise(function (resolve) {
        self.$api.post({
          noLoading: true,
          sc: 'mobileMarketingH5',
          url: 'questionActivity/queryUserQuestionAnswer',
          params: {
            activityCode: self.activityCode,
            userUnionid: self.userUnionid || '',
            loginType: loginType,
            userOpenid: self.userOpenid || '',
            alipayUserId: self.alipayUserId || '',
            associationActivityCode: sessionStorage.getItem('associationActivityCode') || '',
          },
          success: async (r) => {
            let list = r.result || [];
            self.submitedTimes = list.length;
            if (
              list &&
              list.length > 0 &&
              extendConfig.times != 'manyTimes' &&
              list[0].questionType != 'pk_choice' &&
              self.formCustom.formType === FormType.interestForm
            ) {
              // 趣味表单
              self.oldActivity = list;
              self.loginCount = list[0].loginCount;
              sessionStorage.setItem('answer', JSON.stringify(list[0].answerVO));
              // 如果是趣味表单的话，已答过题不允许再参加活动，点击开始答题直接展示抽奖弹窗
              // 趣味表单是一页一题，返回的数据可能是多条，需要缓存下所有数据
              sessionStorage.setItem('interestFormAnswer', JSON.stringify(list));
              resolve();
            } else if (list && list.length > 0 && extendConfig.times != 'manyTimes' && list[0].questionType === 'pk_choice') {
              // 话题pk
              self.oldActivity = list;
              self.loginCount = list[0].loginCount;
              sessionStorage.setItem('answer', JSON.stringify(list[0].answerVO));
              self.questionType = 'pk_choice';
              resolve();
            } else if (list && list.length > 0 && self.formCustom.formType === FormType.commonForm) {
              // 普通表单
              self.oldActivity = list;
              self.loginCount = list[0].loginCount;
              sessionStorage.setItem('answer', JSON.stringify(list[0].answerVO));
              self.formData = await self.getCommonFormIReEnrollFlag();
              if (self.formData.maximumFillInTimes) {
                //maximumFillInTimes 是否超过最大填写次数
                let message = '';
                if (self.formData.questionLimitPeriodCondition) {
                  if (self.formData.questionLimitPeriodCondition === QuestionLimitPeriodCondition.day) {
                    // 超过每日填写次数
                    message = '亲，今天已达最大填写次数！';
                  } else if (self.formData.questionLimitPeriodCondition === QuestionLimitPeriodCondition.month) {
                    // 超过每月填写次数
                    message = '亲，当月已达最大填写次数！';
                  } else {
                    // 超过总共填写次数
                    message = '亲，已达最大填写次数！';
                  }
                }
                resolve({
                  message: message,
                  maximumFillInTimesFlag: true,
                });
              } else {
                if (self.formData.bounceFrameFlag) {
                  if (self.formData.bounceFrameFlag === '1') {
                    resolve({
                      message: '您已经参与过这个活动，是否重新参加？',
                      maximumFillInTimesFlag: false,
                    });
                  } else {
                    resolve({
                      message: '您已参与过这个活动，是否进行修改？',
                      maximumFillInTimesFlag: false,
                    });
                  }
                } else {
                  resolve(false);
                }
              }
            } else {
              resolve(false);
            }
          },
        });
      });
    },
    myAlert(content, title) {
      let self = this;
      return new Promise(function (resolve) {
        Dialog.alert({
          title: title || '提示',
          message: `<p>${content}</p>`,
          showCancelButton: false,
        }).then(() => {
          resolve('ok');
        });
      });
    },
    myConfirm(content, title) {
      let self = this;
      return new Promise(function (resolve) {
        Dialog.confirm({
          title: title || '提示',
          message: `<p>${content}</p>`,
        })
          .then(() => {
            resolve('ok');
          })
          .catch(() => {
            resolve(false);
          });
      });
    },
    // 判断扫码跳转的活动页面
    handleJudgeActivityPage(r, extendConfig) {
      if (r && (this.userUnionid || this.alipayUserId)) {
        // 用户已登录（未参加活动/已参加 且点击“是否重新参加活动【确定】按钮）
        // revise是否可修改
        if (JSON.stringify(this.formData) !== '{}') {
          // 填写过表单
          if (this.formData.maximumFillInTimes) {
            //达到最大填写次数  点确认需要到详情页
            this.jumpSubmittedFormOrNextActivity(extendConfig);
          } else if (this.formData.bounceFrameFlag) {
            // "您已经参与过这个活动，是否重新参加？" 点确认跳填写页面
            this.sethdPage();
          } else if (extendConfig && extendConfig.revise === 'false' && extendConfig.times == 'once') {
            // 单次提交&&可修改是否
            this.jumpSubmittedFormOrNextActivity(extendConfig);
          } else if (this.formData.showDetailFlag) {
            // showDetailFlag 单次有限制条件不修改是否进入详情页 false:不进入;true:进入
            this.jumpSubmittedFormOrNextActivity(extendConfig);
          } else {
            this.sethdPage();
          }
        } else if (JSON.stringify(this.formData) === '{}') {
          // 没有填写过表单
          this.sethdPage();
        }
      } else if (r === false && !this.isRefsh) {
        // 用户已参加过活动，点击“是否重新参加活动【取消】按钮”
        if (extendConfig && extendConfig.nextActivity) {
          const path = '/hdmain?activityCode=' + extendConfig.nextActivity;
          this.$router.push({
            path: path,
          });
          this.$store.commit('base/setIsRouterAlive', false);
          this.$nextTick(() => this.$store.commit('base/setIsRouterAlive', true));
        } else {
          this.sethdPage(true);
        }
      } else {
        // 用户未登录小程序进入H5页面
        this.sethdPage();
      }
    },

    // 判断是否弹"您已经参与过这个活动，是否重新参加？"的弹窗
    async getCommonFormIReEnrollFlag() {
      const self = this;
      return new Promise(function (resolve) {
        self.$api.post({
          noLoading: true,
          sc: 'mobileMarketingH5',
          url: 'questionActivity/queryMiniActivityQuestionDetail/' + self.activityCode,
          params: {
            longitude: '',
            dimension: '',
          },
          success: (r) => {
            if (r.code == 200 && r.result) {
              let formData = {
                bounceFrameFlag: r.result.bounceFrameFlag, //是否弹重新填写弹窗
                maximumFillInTimes: r.result.maximumFillInTimes, //是否超过最大填写次数
                questionLimitPeriodCondition: '', //限制是每日、每月、总共、无限制填写
                showDetailFlag: r.result.showDetailFlag, //为true时，扫码直接跳转表单详情页或表单配置的下一级页面
              };
              if (r.result.activityConfig && r.result.activityConfig.questionLimitPeriodCondition) {
                formData.questionLimitPeriodCondition = r.result.activityConfig.questionLimitPeriodCondition;
              }
              resolve(formData);
            }
          },
          failure: (err) => {
            console.log('err======', err);
            resolve({});
          },
        });
      });
    },
    //微信环境内使用，即微信内置浏览器或小程序内,config接口注入权限验证配置并申请所需开放标签
    weChatOpenAuth() {
      const self = this;
      const formCustom = Object.assign({}, self.formCustom);
      let shareTitle = formCustom.shareTitle;
      let shareDesc = formCustom.shareDesc;
      let shareFlag = formCustom.shareFlag;
      let shareIconUrl = '';
      if (formCustom.shareIconUrl) {
        shareIconUrl =
          formCustom.shareIconUrl.indexOf('{') > -1
            ? self.$utils.getImageUrl(JSON.parse(formCustom.shareIconUrl).file)
            : self.$utils.getImageUrl(formCustom.shareIconUrl);
      }
      let url = window.location.origin + '/hd/hdmain?activityCode=' + formCustom.activityCode;
      const param = window.location.href;
      let href = window.location.href;
      console.log('href--->>:', href);
      // groupmessage   分享到群,timeline  分享到朋友圈,singlemessage  分享到好友
      if (href && (href.indexOf('groupmessage') > -1 || href.indexOf('singlemessage') > -1 || href.indexOf('timeline') > -1)) {
        href = href.replace(/(\?|\&)from=(groupmessage|singlemessage|timeline)(\S*)/, '');
        window.location.href = href;
      }
      let shareCache = sessionStorage.getItem('wxShareParam');
      console.log('shareCache--->>:', shareCache);
      if (shareCache) {
        shareCache = JSON.parse(shareCache);
        shareTitle = shareCache.shareTitle;
        shareDesc = shareCache.shareDesc;
        shareIconUrl = shareCache.shareIconUrl;
        url = window.location.origin + '/hd/hdmain?activityCode=' + shareCache.code;
        shareFlag = shareCache.shareFlag;
      }
      const wxShareParams = {
        shareTitle,
        shareDesc,
        shareIconUrl,
        shareFlag,
        url,
      };
      self.$store.commit('base/setWxShareParams', wxShareParams);
      console.log('1执行getShareParams', formCustom);
      self.$api.post({
        sc: 'mobileMarketingH5',
        url: `getShareParams?url=${encodeURIComponent(getSignUrl())}`,
        success: (r) => {
          const result = r.result || {};
          const appId = result.appId;
          const timestamp = result.timestamp;
          const nonceStr = result.nonceStr;
          const signature = result.signature;
          wx.config({
            debug: false,
            appId: appId,
            timestamp: timestamp,
            nonceStr: nonceStr,
            signature: signature,
            jsApiList: [
              'updateAppMessageShareData',
              'updateTimelineShareData',
              'hideAllNonBaseMenuItem',
              'showAllNonBaseMenuItem',
              'chooseImage',
              'previewImage',
              'uploadImage',
              'downloadImage',
              'onMenuShareTimeline',
            ],
            openTagList: ['wx-open-launch-weapp', 'wx-open-subscribe'], // 可选，需要使用的开放标签列表，微信开放标签是微信公众平台面向网页开发者提供的扩展标签集合。通过使用微信开放标签，网页开发者可安全便捷地使用微信或系统的能力，为微信用户提供更优质的网页体验
            success: function (data) {
              console.log('js方法注入成功1');
              console.log(data);
            },
            fail: function (data) {
              console.log('js方法注入失败1');
              console.log(data);
            },
          });
          wx.ready(function () {
            if (shareFlag === '0') {
              console.log('禁用了分享');
              // 隐藏所有非基础按钮接口
              wx.hideAllNonBaseMenuItem();
            } else {
              //配置为打开分享 shareFlag '1'
              wx.showAllNonBaseMenuItem();
              console.log('标题：', shareTitle);
              console.log('副标题：', shareDesc);
              console.log('link地址：', url);
              console.log('图片地址：', shareIconUrl);
              wx.updateAppMessageShareData({
                title: shareTitle,
                desc: shareDesc,
                link: url,
                imgUrl: encodeURI(shareIconUrl),
              });
              wx.updateTimelineShareData({
                title: shareTitle,
                link: url,
                imgUrl: encodeURI(shareIconUrl),
              });
            }
          });
          wx.error(function (res) {
            console.error('wx.config()错误！', res);
          });
        },
      });
    },

    // 统计导购小程序的推广活动
    handleActivityTaskUpdate(params) {
      this.$api.post({
        noLoading: true,
        sc: 'mobileMarketingH5',
        url: 'ArrangementActivity/activityTaskUpdate',
        params: {
          guideUserId: params.guideUserId,
          taskCode: params.taskCode,
          openId: this.userUnionid,
        },
        success: (r) => {
          if (r.code == 200) {
            console.log('导购小程序活动推广');
          }
        },
      });
    },
    // 支付宝浏览器或者支付宝小程序环境就加载一次alipaysdk
    async loadAliPaySDK() {
      try {
        const Env = await getEnvMark();
        if (Env === EnvMark.alipayH5 || Env === EnvMark.alipayMp) {
          // 加载Alipay JSSDK
          loadAlipayJsapiScript();
          // 加载支付宝的webview SDK
          loadAlipayWebViewScript();
        }
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.hd-runtime-main {
  page-break-before: always;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  -ms-flex-pack: center;
  justify-content: center;
  -ms-overflow-style: none;
  overflow: -moz-scrollbars-none;
  &::-webkit-scrollbar {
    display: none;
  }
  &::-webkit-scrollbar {
    width: 0 !important;
  }
}
.hd-main-model {
  position: fixed;
  overflow: auto;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1900;
  -webkit-overflow-scrolling: touch;
  outline: 0;
  page-break-before: always;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  -ms-flex-pack: center;
  justify-content: center;
  flex-direction: column;
}
.formEnd {
  font-size: 16px;
  .formEndTitle {
    font-size: 18px;
    font-weight: bold;
    padding: 20px 0;
  }
  .formEndText {
    font-size: 14px;
    text-align: center;
  }
}
.hd-runtime-main .ivu-modal-mask {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(55, 55, 55, 0.25);
  height: 100%;
  z-index: 1000;
}

.is-expired-text {
  background-color: #ffffff;
  width: 300px;
  text-align: center;
  padding: 20px;
  font-size: 18px;
}
.fixedPage {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.imgRadious {
  border-radius: 10px 10px 0 0;
}
.textRadious {
  border-radius: 0 0 10px 10px;
}
.radio-title {
  word-wrap: break-word;
}
.radio-options-label {
  max-width: 80%;
  word-wrap: break-word;
}
.dynamic-attr-text-title {
  word-wrap: break-word;
}
body {
  color: #333 !important;
  overflow-x: hidden;
}
.scale-1px {
  position: relative;
  border: none !important;
}
.scale-1px:after {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 1px;
  content: ' ';
  background: #e5e5e5;
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5);
  -webkit-transform-origin: 0 0;
  transform-origin: 0 0;
}
.ihr {
  transform: scaleY(0.5);
}
.i-circle,
.i-check-circle {
  width: 16px !important;
  height: 16px;
  background: url('../../../../static/runtime/images/magic/radio.png') no-repeat;
  background-size: 100%;
}
.i-check-circle {
  background-image: url('../../../../static/runtime/images/magic/radioSelected.png');
}
.i-circle:before,
.i-check-circle:before,
.i-square:before,
.i-check-square:before {
  content: ' ';
}
.i-square,
.i-check-square {
  width: 16px !important;
  height: 16px;
  background: url('../../../../static/runtime/images/magic/checkbox.png') no-repeat;
  background-size: 100%;
}
.i-check-square {
  background-image: url('../../../../static/runtime/images/magic/checkboxSelected.png');
}
.i-circle[disabled],
.i-check-circle[disabled],
.i-square[disabled],
.i-check-square[disabled] {
  opacity: 0.3;
}
.errorTip {
  height: 38px;
  line-height: 40px;
  background: #ffe5e0;
  border-radius: 4px;
  font-size: 12px;
  color: #ff3c16;
  text-indent: 10px;
  margin: 10px 0;
}
.dynamic-property-form {
  background: #fff;
}
.formBg {
  background-color: #ffffff !important;
}
</style>



// WEBPACK FOOTER //
// src/page/vibrantRubikCube/runtime/hdmain.vue